import { Fragment, ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "../../auth/auth";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import { logout } from "../../common/common";
import { isEmpty } from "underscore";
import {
  fetchProfileDataThunk,
  setUserDetailsThunk,
} from "../../store/thunks/userInfo.thunk";
import { updateMetaThunk } from "../../store/thunks/common.thunk";
interface Props {
  children?: ReactNode;
}

const AuthContainer = ({ children }: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const auth = Auth.getInstance();

  const { details, profileData } = useAppSelector(
    (state) => state.rootReducer.userInfoReducer
  );
  useEffect(() => {
    if (isEmpty(details)) {
      dispatch(setUserDetailsThunk());
    }
    if (isEmpty(profileData)) {
      dispatch(fetchProfileDataThunk());
    } else {
      dispatch(updateMetaThunk());
    }
  }, [details, profileData, dispatch]);

  useEffect(() => {
    const access_token: string | null = auth.getAccessToken();
    const refresh_token: string | null = auth.getRefreshToken();

    if (access_token === null && refresh_token === null) {
      logout();
    } 
  }, [auth, navigate, dispatch]);

  return <Fragment>{children}</Fragment>;
};

export default AuthContainer;
